import { createSelector } from 'reselect';
import { selectAirSegments } from './trip.selector';

export const selectSeatsFeatureState = (state) => state.seat;

export const selectSeatMaps = createSelector(selectSeatsFeatureState, (state) => state.seatMaps);

export const selectSeatSelection = createSelector(
  selectSeatsFeatureState,
  (state) => state.seatSelection
);

export const selectActiveSegmentId = createSelector(
  selectSeatsFeatureState,
  (state) => state.activeSegmentId
);

export const activeSeatMap = createSelector(
  selectSeatMaps,
  selectActiveSegmentId,
  (seatMaps, activeSegmentId) => seatMaps && activeSegmentId && seatMaps[activeSegmentId]
);

export const selectActiveSeatMapNotAvailable = createSelector(
  activeSeatMap,
  (state) => state && state.ErrorMessage && state.ErrorMessage === 'Seat map not available.'
);

export const selectActiveSeatMap = createSelector(activeSeatMap, (state) => {
  if (state && state.ClassesOfService) {
    return state.ClassesOfService.reduce((acum, { Rows }, index) => {
      const newRows = Rows.map((row) => ({
        ...row,
        classOfService: index,
      }));

      if (index > 0) {
        acum.push({
          ...newRows[0],
          newService: true,
        });

        return acum.concat(newRows.slice(1));
      }

      return acum.concat(newRows);
    }, []);
  }

  return state;
});

export const selectActiveSeatSegment = createSelector(
  selectAirSegments,
  selectActiveSegmentId,
  (airSegments, activeSegmentId) =>
    airSegments && airSegments.find((x) => x.SegmentId === activeSegmentId)
);

export const selectSeatSegmentTotals = createSelector(selectSeatSelection, (seatSelection) => {
  if (seatSelection) {
    return Object.keys(seatSelection).reduce((r, c) => {
      if (seatSelection[c]) {
        r[c] = Object.values(seatSelection[c]).reduce((pr, pc) => (pr += Number(pc.Price)), 0);
      }
      return r;
    }, {});
  } else {
    return {};
  }
});

export const selectTotalSeatPrice = createSelector(
  selectSeatSegmentTotals,
  (state) => state && Object.values(state).reduce((r, c) => (r += Number(c)), 0)
);

export const selectSeatSelectionBySeatNumber = createSelector(selectSeatSelection, (state) => {
  if (state) {
    return Object.keys(state).reduce((r, segment) => {
      if (state[segment]) {
        r[segment] = {};
        Object.values(state[segment]).forEach((passenger) => {
          if (passenger && passenger.SeatNumber) {
            r[segment][passenger.SeatNumber] = true;
          }
        });
      }
      return r;
    }, {});
  }
});
